export default function accountingNotation(value) {
    const valueAsString = value.toString();
    if (valueAsString[0] === '-') {
        return `(${valueAsString.slice(1)})`;
    }
    return valueAsString;
}
